import React, { useState } from 'react';
import './ComponentContato.css';

function ComponentContato() {
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [categoria, setCategoria] = useState('');
  const [mensagem, setMensagem] = useState('');

  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    empresa: '',
    telefone: '',
    mensagem: '',
    website: ''
  });

  const [formStatus, setFormStatus] = useState({
    submitting: false,
    submitted: false,
    error: false,
    message: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormStatus({ submitting: true, submitted: false, error: false, message: '' });
    try {
      const res = await fetch('/contact.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          nome: formData.nome,
          email: formData.email,
          mensagem: formData.mensagem,
          empresa: formData.empresa,
          telefone: formData.telefone,
          website: formData.website // honeypot
        })
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data?.error || 'Falha ao enviar. Tente novamente.');
      }
      setFormStatus({ submitting: false, submitted: true, error: false, message: '' });
      setFormData({ nome: '', email: '', empresa: '', telefone: '', mensagem: '', website: '' });
    } catch (err) {
      setFormStatus({ submitting: false, submitted: false, error: true, message: err.message });
    }
  };

  return (
    <>
    {formStatus.submitted ? (
                <div className="bg-green-50 border border-green-200 rounded-md p-6 text-center">
                  <svg className="mx-auto h-12 w-12 text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <h3 className="mt-3 text-lg font-medium text-green-800">Mensagem enviada com sucesso!</h3>
                  <p className="mt-2 text-sm text-green-700">
                    Agradecemos seu contato. Nossa equipe responderá em breve.
                  </p>
                  <div className="mt-6">
                    <button
                      type="button"
                      onClick={() => setFormStatus({ submitting: false, submitted: false, error: false, message: '' })}
                      className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                    >
                      Enviar nova mensagem
                    </button>
                  </div>
                </div>
              ) : (
    <form onSubmit={handleSubmit} className='p-8 pt-5 rounded-lg font-sans shadow-2xl shadow-blue-500/50' style={{ width:'400px', height: '450px', backgroundColor: '#004e80' }}>
      <h3 className='text-center normal-case text-white font-sans mb-3 text-xl font-raleway font-medium'>Formulário</h3>
      <div className='mb-4'>
        <input type="text" className='w-full bg-white rounded-lg h-10 p-3' placeholder='Nome' value={nome} onChange={(event) => setNome(event.target.value)} required />
      </div>
      <div className='mb-4'>
        <input type="text" className='w-full bg-white rounded-lg h-10 p-3' placeholder='E-mail' value={email} onChange={(event) => setEmail(event.target.value)} required />
      </div>
      <div className='mb-4'>
        <select
          className='w-full bg-white rounded-lg h-10 pl-3'
          value={categoria}
          onChange={(event) => setCategoria(event.target.value)}
          required
        >
          <option value="" disabled>Deseja entrar em contato com</option>
          <option value="administrativo">Administrativo</option>
          <option value="comercial">Comercial</option>
          <option value="contabilidade">Contabilidade</option>
          <option value="financeiro">Financeiro</option>
          <option value="juridico">Jurídico</option>
          <option value="ti">Tecnologia da informação</option>
          <option value="outros">Outros</option>
        </select>
      </div>
      <div className='mb-2'>
        <textarea type="text" className='w-full bg-white rounded-lg h-36 p-3' placeholder='Mensagem' value={mensagem} onChange={(event) => setMensagem(event.target.value)} required />
      </div>
      <button type="submit" className='w-full text-white border-none rounded-lg py-2 px-4 cursor-pointer h-10 ' style={{ backgroundColor: '#c76f36' }}>Enviar</button>
    </form>
    )}
    </>
  );
}

export default ComponentContato;
